<template>
    <v-tabs v-model="active_tab" slider-color="black" grow lazy>
        <v-tab>Your Data</v-tab>
        <v-tab>Benchmark</v-tab>
        <v-tab>Segmentation</v-tab>
        <v-tab>Cohorts</v-tab>
        <v-tabs-items>
            <v-tab-item>
                <v-card flat>
                    <v-divider></v-divider>
                    <your-data v-on:next="next"></your-data>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-divider></v-divider>
                    <benchmark v-on:next="next"></benchmark>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-divider></v-divider>
                    <segment v-on:next="next"></segment>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-divider></v-divider>
                    <cohort v-on:next="next"></cohort>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-tabs>
</template>
<script>
    import YourData from "../../Shared/YourData/YourData";
    import Benchmark from "../../Shared/Benchmark/Benchmark";
    import Segment from "../../Shared/Segment/Segment";
    import Cohort from "../../Shared/Cohort/Cohort";

    export default {
        components: {
            YourData,
            Benchmark,
            Segment,
            Cohort
        },
        data() {
            return {
                active_tab: 0,
                routerLink: {
                    text: 'Commercial',
                    value: 'Commercial'
                },
            };
        },
        watch: {
            active_tab: function (val) {
                this.$store.dispatch('AppStore/SetTab', val)
            }
        },
        methods: {
            next() {
                if (this.active_tab < 3) {
                    this.active_tab = this.active_tab + 1;
                }
                else this.active_tab = 0;
            }
        },
        created() {
            this.$store.dispatch('AppStore/SetProductLine', this.PRODUCT_LINE_COMMERCIAL);
            this.$store.dispatch('AppStore/SetTab', this.TAB_YOUR_DATA);
            this.$store.dispatch('AppStore/SetRouterLink', this.routerLink);
        }
    };
</script>
<style>
</style>